/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from '../../services/toaster.service';
import { responseStatus } from '../const/responseStatus.const';

@Injectable({
  providedIn: 'root'
})
export class GetInterceptor implements HttpInterceptor {
  constructor(
    private _toastrService: ToasterService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Handle success response
          }
        },
        error: (error: HttpErrorResponse) => {
          const errorMessage =
            error.error?.message || this.translateService.instant('networkConnection');
          switch (error.status) {
          case responseStatus.BADREQUEST: {
            this._toastrService.errToastr(errorMessage);
            break;
          }
          case responseStatus.UNAUTHORIZED: {
            this._toastrService.errToastr(
              'Someone has logged into your account. Please log in again.'
            );
            localStorage.clear(); // Clear local storage
            setTimeout(() => {
              window.location.href = 'https://restaurant.xploraluxe.com';
            }, 900);
            break;
          }
          case responseStatus.FORBIDDEN: {
            this._toastrService.errToastr(errorMessage);
            this.router.navigate(['/']);
            break;
          }
          case responseStatus.REQUESTTIMEOUT: {
            this._toastrService.errToastr(errorMessage);
            break;
          }
          case responseStatus.INTERNALSERVERERROR: {
            this._toastrService.errToastr(errorMessage);
            break;
          }
          case responseStatus.RequestTookMoreThanExpected: {
            this._toastrService.errToastr(errorMessage);
            break;
          }
          case responseStatus.GatewayTimeOut: {
            this._toastrService.errToastr(errorMessage);
            break;
          }
          default: {
            this._toastrService.errToastr(errorMessage);
          }
          }
        }
      })
    );
  }
}

